module.exports = __webpack_public_path__ + "img/MG-TITLE-01-MOBILE.48e4f24b.png";